import React, { useState } from 'react'

import { CustomTheme, greenPrimary } from '@masfront/common-b2c'

import { FormControl, Select, Box, InputLabel, MenuItem } from '@material-ui/core'
import { makeStyles, createStyles } from '@material-ui/styles'

import { CareMockDB } from '~/mockDB'

const useStyles = makeStyles((theme: CustomTheme) => {
  return createStyles({
    formControl: {
      margin: theme.spacing(3, 0),
      width: theme.spacing(115),
      '& .MuiSelect-select:focus': {
        background: 'none',
      },
      '& .MuiFormLabel-root.Mui-focused': {
        color: greenPrimary,
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: greenPrimary,
      },
    },
    selectOutlined: {
      display: 'flex',
      justifyContent: 'space-between',
      '& .MuiTypography-root': {
        paddingRight: theme.spacing(4),
      },
    },
    item: {
      justifyContent: 'space-between',
    },
  })
})

export interface AgentSelectProps {
  onChangeAgent?: (agentNameId: string) => void
}

const AgentSelect: React.FC<AgentSelectProps> = ({ onChangeAgent = () => ({}) }) => {
  const classes = useStyles()
  const styleClasses = {
    selectOutlined: classes.selectOutlined,
  }

  const [selectedId, setSelectedId] = useState('')

  function onChangeSelected(agentNameId: string) {
    onChangeAgent(agentNameId)
    setSelectedId(agentNameId)
  }

  const agentInfoMocks = Object.values(CareMockDB).filter(
    (mockInfo) => mockInfo.mockType === 'AgentInfoMock',
  )

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel htmlFor="outlined-age-native-simple">Agente</InputLabel>
      <Select
        data-hook="agent-mock-select"
        classes={{ outlined: styleClasses.selectOutlined }}
        value={selectedId}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={(event: any) => onChangeSelected(event.target.value)}
        label="Agent"
      >
        {agentInfoMocks.map((agentInfoMock, i) => {
          if (agentInfoMock.mockType === 'AgentInfoMock') {
            return (
              <MenuItem
                key={agentInfoMock.nameId}
                data-hook={`agent-mock-select-menu-item-${agentInfoMock.sub}`}
                className={classes.item}
                value={agentInfoMock.nameId}
              >
                <Box>{agentInfoMock.sub}</Box>
              </MenuItem>
            )
          }
          return null
        })}
      </Select>
    </FormControl>
  )
}

export default AgentSelect
